<template>
    <el-dialog :visible="visible" :modal-append-to-body="false" class="ah-detail-dialog update-401-code-dialog" append-to-body :before-close="onClose" @open="onOpen">
        <template slot="title"> 編輯 </template>
        <el-form ref="form" :model="form" class="detail-row">
            <el-form-item label="格式代號" prop="code">
                <el-select v-model="form.code" placeholder="請選擇">
                    <el-option v-for="item in codeOptions" :key="item.value" :label="item.label" :value="item.value">
                        <span style="margin-bottom: 0; padding-right: 15px">{{ item.label }}</span>
                        <span style="color: #8492a6; font-size: 13px; margin-top: -10px">{{ item.info }}</span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-button type="" @click="onClose">取消</el-button>
            <el-button type="primary" :loading="isLoading" :disabled="!form.code" @click="onSubmit">
                確定
            </el-button>
        </el-form>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import { mapState, mapMutations, mapActions } from 'vuex';
import { invoiceCodeOptions, paymentCodeOptions } from './CodeOptions';

export default {
    props: {
        visible: Boolean,
        target: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        ...mapState({
            selectedItems: (state) => state.businessTax.selectedItems,
        }),
        isTargetIncome() {
            return !!this.target?.ioo;
        },
        codeOptions() {
            if (this.isTargetIncome) {
                return invoiceCodeOptions.filter((o) => !!o.value);
            }
            return paymentCodeOptions.filter((o) => !!o.value);
        },
    },
    data() {
        return {
            form: { code: null },
            isLoading: false,
        };
    },
    methods: {
        ...mapMutations({
            onClearSelection: 'businessTax/onClearSelection',
        }),
        ...mapActions({
            updateDeclaredData: 'businessTax/updateDeclaredData',
        }),
        onOpen() {
            this.form.code = Number(this.target.code);
        },
        async onSubmit() {
            this.isLoading = true;
            try {
                await this.onItemCodeInput(this.target.sno, this.form.code, this.target.taxCredited, this.target.isTranInovice);
                this.updateDeclaredData();
                this.onClearSelection();
                this.onClose();
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        async onItemCodeInput(sno, code, isTCIN, isTranInovice) {
            try {
                // 發送更新Api
                if (isTCIN) {
                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/UpdatePayInvoice401Code',
                        data: {
                            updateType: this.target.ioo ? 1 : 2,
                            code401s: [{ sno, code }],
                        },
                        method: 'POST',
                    });
                    console.log('UpdateTCIN401Code', resp);
                } else if (isTranInovice) {
                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/Update401Code',
                        data: {
                            updateType: 5,
                            code401s: [{ sno, code }],
                        },
                        method: 'POST',
                    });
                    console.log('Tran Update401Code', resp);
                } else {
                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/Update401Code',
                        data: {
                            updateType: this.target.ioo ? 1 : 2,
                            code401s: [{ sno, code }],
                        },
                        method: 'POST',
                    });
                    console.log('Update401Code', resp);
                }

                // 更新LocalStorage
                const LOCAL_DATA_NAME = this.target.ioo ? '401-selected-invoice' : '401-selected-payment';
                const LOCAL_DATA = JSON.parse(window.localStorage.getItem(LOCAL_DATA_NAME)) || [];
                const FOUND_INDEX = _.findIndex(LOCAL_DATA, ['sno', sno]);

                if (FOUND_INDEX >= 0) {
                    const dataChanged = LOCAL_DATA[FOUND_INDEX];
                    dataChanged.code = code;
                    window.localStorage.setItem(LOCAL_DATA_NAME, JSON.stringify(LOCAL_DATA));
                }
            } catch (e) {
                console.log(e);
            }
        },
        onClose() {
            this.form.type = null;
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss">
.update-401-code-dialog {
    display: flex;
    .el-dialog {
        width: 100%;
        max-width: 550px;
        margin: auto !important;
    }
}
</style>
